import { numberUtils, useVisibility } from '@zg-rentals/rental-manager-env';
import { Box, Button, Text, TextButton } from '@zillow/constellation-10';
import { IconChevronLeftOutline } from '@zillow/constellation-icons';

interface TaskFooterProps {
  handleBackButton: () => void;
  handleNext?: () => void;
  customNextText?: string;
  isHandlingNext?: boolean;
  isNextDisabled?: boolean;
  subTotal?: number;
}

export const GuestPayFooter = ({
  handleBackButton,
  handleNext,
  customNextText,
  isHandlingNext,
  isNextDisabled,
  subTotal,
}: TaskFooterProps) => {
  const { isVisible, isVisibleRef } = useVisibility({ offset: -100, throttleMilliseconds: 200 });

  return (
    <>
      <div ref={isVisibleRef} />
      <Box
        css={{
          position: isVisible ? 'static' : 'fixed',
          boxShadow: isVisible ? '0' : '0 0 7px -2px rgba(0, 0, 0, 0), 0 0 3px 0 rgba(0, 0, 0, 0.26)',
          borderTop: '1px solid',
          borderColor: 'gray.300',
          bottom: 0,
          left: 0,
          width: '100%',
          background: 'white',
          zIndex: 270,
          minHeight: '114px',
          display: 'flex',
          padding: 'sm',
        }}
      >
        <Box
          css={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            maxWidth: '1232px',
            margin: '0 auto',
            paddingInline: '0',
            paddingBlock: isVisible ? '0' : 'md',
          }}
        >
          <Box
            css={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <TextButton icon={<IconChevronLeftOutline />} onClick={handleBackButton} disabled={isHandlingNext}>
              Back
            </TextButton>
          </Box>
          <Box css={{ display: 'flex', alignItems: 'center', gap: 'md' }}>
            {typeof subTotal !== 'undefined' && (
              <Text textStyle="heading-xs">{`Subtotal: ${numberUtils.asCurrency(subTotal)}`}</Text>
            )}
            <Button tone="brand" emphasis="filled" onClick={handleNext} disabled={isHandlingNext || isNextDisabled}>
              {isHandlingNext ? 'Loading...' : customNextText || 'Next'}
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};
